import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import course from './views/Course.vue'
import school from './views/School.vue'
import schoolLabel from './components/school/schoolLabel.vue'
import schoolDetails from './components/school/schoolDetails.vue'
import ecology from './views/Ecology.vue'
import about from './views/About.vue'
import service from './components/about/service.vue'
import solution from './views/Solution.vue'
import pcEducation from './components/solution/pcEducation.vue'
import bIndustry from './components/solution/bIndustry.vue'
import livingCode from './components/product/livingCode.vue'
import SCRM from './components/product/SCRM.vue'
import shopping from './components/product/shopping.vue'
import o2o from './components/product/o2o.vue'
import price from './views/Price.vue'
import Case from './views/Case.vue'
import casede from './components/case/casede.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    //首页
    {
      path: '/',
      name: 'home',
      component: Home
    },
    //案例
    {
      path: '/case',
      name: 'case',
      component: Case
    },
    {
      path: '/casede',
      name: 'casede',
      component: casede
    },
    //课程
    {
      path: '/course',
      name: 'course',
      component: course
    },
    //学堂
    {
      path: '/school',
      name: 'school',
      component: school
    },
    {
      path: '/schoolLabel',
      name: 'schoolLabel',
      component: schoolLabel
    },
    {
      path: '/schoolDetails',
      name: 'schoolDetails',
      component: schoolDetails
    },
    //生态
    {
      path: '/ecology',
      name: 'ecology',
      component: ecology
    },
    //关于我们
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/service',
      name: 'service',
      component: service
    },
    //解决方案
    {
      path: '/solution',
      name: 'solution',
      component: solution
    },
    {
      path: '/pcEducation',
      name: 'pcEducation',
      component: pcEducation
    },
    {
      path: '/bIndustry',
      name: 'bIndustry',
      component: bIndustry
    },
    //产品
    {
      path: '/livingCode',
      name: 'livingCode',
      component: livingCode
    },
    {
      path: '/SCRM',
      name: 'SCRM',
      component: SCRM
    },
    {
      path: '/shopping',
      name: 'shopping',
      component: shopping
    },
    {
      path: '/o2o',
      name: 'o2o',
      component: o2o
    },
    //价格
    {
      path: '/price',
      name: 'price',
      component: price
    },
  ]
})
